import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'textTransform',
  standalone: true,
})
export class TextTransformPipe implements PipeTransform {
  transform(
    value: string | null | undefined,
    mode: 'titlecase' | 'uppercase' | 'lowercase' = 'titlecase',
  ): string {
    if (!value) return '';

    switch (mode) {
      case 'titlecase':
        return value
          .toLowerCase()
          .replace(/\b\w/g, (char) => char.toUpperCase());

      case 'uppercase':
        return value.toUpperCase();

      case 'lowercase':
        return value.toLowerCase();

      default:
        return value;
    }
  }
}